// extracted by mini-css-extract-plugin
export default {"textBlock":"TypeText_textBlock__7ozi0"};